import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import Loader from '../../../../components/common/Loader'
import { SpacingContainer } from '../../../../components/common/Containers'
import MonthNav from './MonthNav'
import CalendarGrid from './CalendarGrid'
import MobileDayList from './MobileDayList'
import { actions, selectCalendar } from '../../../../store/eventsManagement'
import { selectUserPermissions, isEnabled } from '../../../../selectors'
import { useMediaQueryDown } from '../../../../hooks/useMediaQuery'
import { bucketEventsByDay, DAY_KEY_FORMAT } from './utils'

const MODULE_KEY = 'event-management'

const CalendarView = ({ onEventClick }) => {
  const dispatch = useDispatch()
  const calendar = useSelector(selectCalendar)
  const permissions = useSelector(selectUserPermissions)
  const canEdit = isEnabled(permissions, MODULE_KEY, '', 'edit')
  const isMobile = useMediaQueryDown('sm')
  const [selectedDay, setSelectedDay] = React.useState(null)

  useEffect(() => {
    if (calendar.month) {
      dispatch(actions.fetchCalendarEvents(calendar.month))
    } else {
      dispatch(actions.initCalendar())
    }
  }, [])

  const buckets = React.useMemo(() => bucketEventsByDay(calendar.items), [calendar.items])

  const changeMonth = (offset) => {
    const next = dayjs(`${calendar.month}-01`).add(offset, 'month').format('YYYY-MM')
    setSelectedDay(null)
    dispatch(actions.fetchCalendarEvents(next))
  }

  const selectedKey = selectedDay ? selectedDay.format(DAY_KEY_FORMAT) : null
  const selectedEvents = selectedKey ? buckets[selectedKey] || [] : []

  return (
    <SpacingContainer px="5sm3" py={2}>
      {calendar.pending && <Loader open={calendar.pending} />}
      {calendar.month && (
        <div>
          <MonthNav month={calendar.month} onPrev={() => changeMonth(-1)} onNext={() => changeMonth(1)} />
          <CalendarGrid
            month={calendar.month}
            buckets={buckets}
            onEventClick={canEdit ? onEventClick : undefined}
            mobile={isMobile}
            selectedKey={selectedKey}
            onSelectDay={isMobile ? setSelectedDay : undefined}
          />
          {isMobile && selectedDay && (
            <MobileDayList day={selectedDay} events={selectedEvents} onEventClick={canEdit ? onEventClick : undefined} />
          )}
        </div>
      )}
    </SpacingContainer>
  )
}

CalendarView.propTypes = {
  onEventClick: PropTypes.func.isRequired,
}

export default CalendarView
